import React, { useEffect } from 'react'
import SiteFooter from '../components/SiteFooter'
import SiteMark from '../components/SiteMark'
import PageHeader from '../components/PageHeader'
import { climateHeader, climateGroups } from '../data/climate'

// What has happened to the region since the film was made. Every card links
// out; the site holds none of this reporting itself.
//
// A card without an image still works, so nothing breaks if one has to come
// down.

const Card = ({ item }) => (
  <li className={`climate-card ${item.image ? '' : 'is-textonly'}`}>
    {item.image && (
      <a className='climate-card-image' href={item.url} target='_blank' rel='noopener noreferrer' tabIndex={-1}>
        <img src={item.image} alt={item.alt || ''} loading='lazy' />
      </a>
    )}
    <div className='climate-card-body'>
      <p className='climate-card-source'>{item.source}<span className='climate-card-dot'>·</span>{item.date}</p>
      <h3 className='climate-card-title'>{item.title}</h3>
      <span className='climate-card-rule' aria-hidden='true' />
      <p className='climate-card-text'>{item.text}</p>
      <p className='climate-card-link'>
        <a className='link-button' href={item.url} target='_blank' rel='noopener noreferrer'>Learn more</a>
      </p>
    </div>
  </li>
)

const ClimateChange = () => {
  useEffect(() => {
    document.title = 'Climate Resilience | The Girl and Her Piano'
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='App page-standard page-climate'>
      <SiteMark />

      <PageHeader
        {...climateHeader}
        title='Climate Resilience'
        subtitle='Glaciers and beyond'
      />

      <main>
        {climateGroups.map((group) => (
          <section className='climate-group' data-tone='light' key={group.title}>
            <div className='content-container'>
              <h2>{group.title}</h2>
              <ul className='climate-cards'>
                {group.items.map((item) => <Card key={item.url} item={item} />)}
              </ul>
            </div>
          </section>
        ))}
        <section className='climate-outro' data-tone='light'>
          <div className='content-container'>
            <h2>A visual story of Bhutan’s glaciers, valleys and people</h2>
            <p className='climate-outro-text'>
              What is threatening Bhutan’s glaciers, and the people who
              depend on them.
            </p>
            <p className='climate-outro-link'>
              <a className='link-button link-button--light' href='/climate-awareness'>Be Aware</a>
            </p>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  )
}

export default ClimateChange
